import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://03326a053e480f48a73ac1616a85c565@o4509685435269120.ingest.us.sentry.io/4509689140150272",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});
